import { render, staticRenderFns } from "./WidgetShippingStatus.vue?vue&type=template&id=afb7301c&scoped=true"
import script from "./WidgetShippingStatus.vue?vue&type=script&lang=js"
export * from "./WidgetShippingStatus.vue?vue&type=script&lang=js"
import style0 from "./WidgetShippingStatus.vue?vue&type=style&index=0&id=afb7301c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb7301c",
  null
  
)

export default component.exports